<template>
  <div style="display:inline-block">
    <a
      style="color:#00897B; padding: 0px 6px"
      :tooltip="$t('reassignCustomer.reassignCustomerTooltip')"
      @click="openDialog()"
    >
      <i class="material-icons">swap_horiz</i>
    </a>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="480px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11>
                <span class="headline"><strong>{{ $t('reassignCustomer.reassignCustomerTooltip') }} <span class="text-primary ml-2">#{{ r.theOrderID }}</span></strong></span>
              </v-flex>
              <v-flex xs1>
                <v-btn flat @click.native="closeDialog()" class="close">
                  <span aria-hidden="true"><i class="material-icons" style="font-size:24px;vertical-align:middle;">close</i></span>
                </v-btn>
              </v-flex>
            </v-card-title>

            <v-card-text>
              <v-alert type="warning" :value="true" style="margin-bottom:12px;">
                {{ $t('reassignCustomer.chargedToLabel') }} <strong>{{ r.full_name }}</strong>. {{ $t('reassignCustomer.pickingDifferentCustomerText', { name: r.full_name, amount: Number(r.total_amount).toFixed(2) }) }}
              </v-alert>

              <v-layout wrap>
                <v-flex xs12 class="px-2">
                  <v-select
                    autocomplete
                    :items="customers"
                    item-text="text"
                    item-value="value"
                    v-model="newCustomerId"
                    :filter="filterCustomers"
                    :error-messages="errors.collect('Customer')"
                    v-validate="'required'"
                    data-vv-name="Customer"
                    :label="$t('reassignCustomer.newCustomerLabel')"
                    single-line
                  ></v-select>
                </v-flex>
                <v-flex xs12 class="px-2">
                  <v-text-field
                    :label="$t('orders.reason') + '*'"
                    v-model="reason"
                    multi-line
                    :rows="2"
                    :error-messages="errors.collect('Reason')"
                    v-validate="'required'"
                    data-vv-name="Reason"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto;color:#989595;"
                @click.native="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="saving"
                style="height:auto"
                outline
                class="blue-logout rtl-mr-1-5pct"
              >{{ $t('common.save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['r', 'getResults'],

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      dialog: false,
      saving: false,
      customers: [],
      newCustomerId: null,
      reason: ''
    }
  },

  methods: {
    openDialog() {
      this.dialog = true
      this.newCustomerId = null
      this.reason = ''
      this.getCustomers()
    },

    closeDialog() {
      this.dialog = false
      this.newCustomerId = null
      this.reason = ''
      this.$validator.reset()
    },

    getCustomers() {
      const token = localStorage.getItem('access_token')

      axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.customers = response.data.data
            .filter((c) => c.user_id !== this.r.customer_id_fk)
            .map((c) => {
              const phone1 = c.phone_number || ''
              const phone2 = c.phone_number_2 || ''
              const phones = [phone1, phone2].filter(Boolean).join(' / ')
              return {
                text: phones ? c.full_name + this.$t('reassignCustomer.telPrefix') + phones : c.full_name,
                value: c.user_id,
                full_name: c.full_name,
                phone_number: phone1,
                phone_number_2: phone2
              }
            })
        })
        .catch((error) => {
          swal(this.$t('common.error'), (error.response && error.response.data.message) || this.$t('reassignCustomer.failedToLoadCustomers'), 'error')
        })
    },

    filterCustomers(item, queryText, itemText) {
      const query = String(queryText || '').toLowerCase().trim()
      if (!query) return true

      const visibleFields = [
        itemText,
        item && item.full_name,
        item && item.phone_number,
        item && item.phone_number_2
      ]
        .filter(Boolean)
        .map(value => String(value).toLowerCase())

      if (visibleFields.some(value => value.includes(query))) {
        return true
      }

      const normalizedQuery = this.normalizePhoneSearch(query)
      if (!normalizedQuery) {
        return false
      }

      return [item && item.phone_number, item && item.phone_number_2]
        .filter(Boolean)
        .some(value => this.normalizePhoneSearch(value).includes(normalizedQuery))
    },

    normalizePhoneSearch(value) {
      return String(value || '').replace(/\D/g, '')
    },

    submitForm() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.confirmAndSubmit()
        }
      })
    },

    confirmAndSubmit() {
      const selected = this.customers.find((c) => c.value === this.newCustomerId)
      const newCustomerName = selected ? selected.full_name : this.$t('reassignCustomer.selectedCustomerFallback')

      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('reassignCustomer.confirmReassignText', { name: this.r.full_name, newName: newCustomerName, amount: Number(this.r.total_amount).toFixed(2) }),
        icon: 'warning',
        buttons: true
      }).then((confirmed) => {
        if (confirmed) {
          this.submit()
        }
      })
    },

    submit() {
      this.saving = true
      const token = localStorage.getItem('access_token')

      axios
        .put(
          `api/orders/${this.r.order_id}/reassign_customer`,
          { new_customer_id_fk: this.newCustomerId, reason: this.reason },
          { headers: { Authorization: 'Bearer ' + token } }
        )
        .then(() => {
          this.saving = false
          this.closeDialog()
          this.getResults()
          swal({ title: this.$t('common.done'), icon: 'success', timer: 1200, buttons: false })
        })
        .catch((error) => {
          this.saving = false
          swal(this.$t('common.error'), (error.response && error.response.data.message) || this.$t('reassignCustomer.failedToReassignCustomer'), 'error')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reassignOrderCustomer.vue